/**
 * We use translations schemas from sanity in main app code for two purposes:
 * 1. define typings for translations
 * 2. get default values for translations
 */
import * as tSchemas from './index';

export const defaultTranslations = {
	accessControl: tSchemas.AccessControlTranslations.fields,
	cart: tSchemas.CartTranslations.fields,
	common: tSchemas.CommonTranslations.fields,
	concepts: tSchemas.ConceptsTranslations.fields,
	collections: tSchemas.CollectionsTranslations.fields,
	bundle: tSchemas.BundleTranslations.fields,
	entities: tSchemas.EntitiesTranslations.fields,
	errors: tSchemas.ErrorsTranslations.fields,
	favorites: tSchemas.FavoritesTranslations.fields,
	forms: tSchemas.FormsTranslations.fields,
	header: tSchemas.HeaderTranslations.fields,
	offerings: tSchemas.OfferingsTranslations.fields,
	orders: tSchemas.OrdersTranslations.fields,
	popular: tSchemas.PopularTranslations.fields,
	products: tSchemas.ProductsTranslations.fields,
	quantity: tSchemas.QuantityTranslations.fields,
	ratingReview: tSchemas.RatingReviewTranslations.fields,
	search: tSchemas.SearchTranslations.fields,
	video: tSchemas.VideoTranslations.fields,
	pageBanner: tSchemas.PageBannerTranslations.fields,
	profile: tSchemas.ProfileTranslations.fields,
} as const;

export type Translations = typeof defaultTranslations;
